<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <div class="d-flex align-items-center">
                <div class="edit">
                  <button (click)="backToMyProject()">
                    <span><i class="ri-arrow-left-line"></i></span>
                  </button>
                </div>
                <h3 class="px-3">My Project</h3>
              </div>
            </div>
            <!-- <div class="col-sm-6 d-flex justify-content-end">
                            <button type="button"  data-bs-toggle="modal" data-bs-target="#opportunity" class="btn btn-icon"><i class="ri-add-line"></i></button>
                        </div> -->
          </div>
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6 d-flex">
              <h3>
                <a (click)="openProjectTab('myparameters')" class="active">Details</a>
              </h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-list')">Sub-Project </a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('issues')"> Issues</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('task')"> Tasks</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('resources')"> Resources</a></h3>
              <!-- <h3>
                <a (click)="this.currentProjectId && openProjectTab('deliverables')"> Deliverables</a>
              </h3>
              <h3>
                <a (click)="this.currentProjectId && openProjectTab('decision-records')">
                  Decision Records</a
                >
              </h3> -->
            </div>
          </div>
          '
          <div class="canvas-data">
            <form [formGroup]="myParametersForm">
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">

                      <input type="text" formControlName="projectName" id="projectName" required />
                      <label class="floating-label">Project Name*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectName.touched && f.projectName.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectName.errors.required">Project Name is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">

                      <input type="text" formControlName="projectCode" id="projectCode" required />

                      <label class="floating-label">Project code*</label>
                      <i class="ri-hashtag"></i>
                    </div>
                    <mat-error *ngIf="f.projectCode.touched && f.projectCode.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectCode.errors.required">Project Code is required</mat-error>
                      <mat-error *ngIf="f.projectCode.errors.pattern">Project Code must contain numbers only</mat-error>
                    </mat-error>
                  </div>
                </div>

                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">

                      <!-- <input type="text" formControlName="projectManager" id="projectManager" required /> -->
                      <input list="taskOwnerDatalist" formControlName="projectManager" />
                      <label class="floating-label">Project Manager*</label>
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>

                      <i class="ri-user-2-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectManager.touched && f.projectManager.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectManager.errors.required">Project Manager is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <!-- <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="rfqDate" id="rfqDate" />
                      <label class="floating-label">RFQ date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div> 
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="quotationDate" />
                      <label class="floating-label">Quotation Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>-->
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">

                      <input type="date" formControlName="startDate" id="startDate" />

                      <label class="floating-label">Start Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                    <mat-error *ngIf="f.startDate.touched && f.startDate.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.startDate.errors.required">Start Date is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="decisionDate" ng-model="valid" />
                      <label class="floating-label">Decision Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="endDate" id="endDate" k.o8 />
                      <label class="floating-label">End Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                    <mat-error *ngIf="f.endDate.touched && f.endDate.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.endDate.errors.required">End Date is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="projectStatus" placeholder="Project Status">
                        <option value="" disabled selected>Project Status</option>
                        <option value="Active">Active</option>
                        <option value="On hold">On hold</option>
                        <option value="Archive">Archive</option>
                      </select>
                      <label for="status" class="floating-label floating-label-special"
                        *ngIf="!this.currentProjectId">Select Status</label>
                      <i class="ri-inbox-archive-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" disabled="true" formControlName="createdBy" />
                      <label class="floating-label-special">Created By</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <!-- <input type="text" formControlName="projectController" id="projectController" required />
                      <label class="floating-label floating-label-special">Project controller*</label> -->
                      <input list="taskOwnerDatalist" formControlName="projectController" />
                      <label class="floating-label">Project Lead Engineer*</label>
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>
                      <i class="ri-user-follow-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectController.touched && f.projectController.invalid"
                      class="alert alert-danger">
                      <mat-error *ngIf="f.projectController.errors.required">Lead Engineer is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="seatingRows" />
                      <label class="floating-label">Seating Rows</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="customer" id="customer" required />
                      <label class="floating-label floating-label-special">Customer*</label>
                      <i class="ri-group-line"></i>
                    </div>
                    <mat-error *ngIf="f.customer.touched && f.customer.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.customer.errors.required">Customer is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="totalHours" />
                      <label class="floating-label">Total Hours</label>
                      <i class="ri-time-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="remainingHours" />
                      <label class="floating-label">Remaining Hours</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="" />
                      <label class="floating-label floating-label-special">Region</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="" />
                      <label class="floating-label floating-label-special">Industry</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="" />
                      <label class="floating-label floating-label-special">Business Group Information</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="" />
                      <label class="floating-label floating-label-special">Commodity Informaion</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div> -->
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="percentWorkCompleted"
                        disabled />
                      <label class="floating-label-special">% of Project Completion</label>
                      <i class="ri-progress-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-2">
                  <div class="input">
                    <div class="input-item">

                      <textarea name="" id="" cols="20" rows="4" formControlName="projectDescription"></textarea>
                      <!-- <input type="text" formControlName="projectDescription" /> -->
                      <label class="floating-label">Project description</label>
                      <i class="ri-file-list-3-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-3 mb-2">
                  <div class="d-flex gap-2 justify-content-end">
                    <div *ngIf="this.isPMOLeadORManager"><a class="btn" (click)="updateorcreateParameters()"
                        [class.disabled]="!myParametersForm.valid ? true : null"
                        *ngIf="this.currentProjectId">Update</a></div>
                    <a class="btn" (click)="updateorcreateParameters()"
                      [class.disabled]="!myParametersForm.valid ? true : null" *ngIf="!this.currentProjectId">Create</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>

<!-- Delete an item -->
<div class="modal fade" id="delete-items" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content pl-5 pr-5">
      <form action="">
        <div class="modal-header">
          <h5 class="modal-title">Are you sure want to delete?</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>
          <a class="btn btn-primary" routerLink="/quotation/opportunity">Yes Delete</a>
        </div>
      </form>
    </div>
  </div>

</div>